import { Component, h, Prop, Host } from '@stencil/core';

@Component({
  tag: 'aha-comment-link',
  styleUrl: 'aha-comment-link.css',
  shadow: true,
})
export class AhaCommentLink {
  /** The URL to link to. */
  @Prop() href: string = '#';

  /** Whether to confirm the data. */
  @Prop({ attribute: 'data-confirm' }) dataConfirm?: string;

  /** Whether to display a remote link. */
  @Prop({ attribute: 'data-remote' }) dataRemote?: string;

  /** The relationship of the link. */
  @Prop() rel?: string;

  /** The method of the link. */
  @Prop({ attribute: 'data-method' }) dataMethod?: string;

  /** Whether to display a line. */
  @Prop() line: boolean = false;

  /** The method of the link. */
  @Prop() onLinkClick?: (event: MouseEvent) => void;

  render() {
    return (
      <Host>
        <a
          href={this.href}
          data-confirm={this.dataConfirm}
          data-remote={this.dataRemote}
          rel={this.rel}
          data-method={this.dataMethod}
          class="aha-comment-link"
          onClick={this.onLinkClick}
        >
          <slot name="body"></slot>
          {this.line && <span class="aha-comment-link__line">|</span>}
        </a>
      </Host>
    );
  }
}
